"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ibantools = require("ibantools");

var _fp = require("lodash/fp");

// IBAN patterns
// on: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// under: IBAN patterns by country
const DEFAULT_PRINT_BLOCK_SIZE = 4;

var _default = (country, printBlockSize = DEFAULT_PRINT_BLOCK_SIZE) => {
  const countrySpec = _ibantools.countrySpecs[country]; // do not fail for unsupported countries: https://github.com/DimaRGB/text-mask-addon-iban/issues/6

  if (!countrySpec || !countrySpec.bban_regexp) {
    return;
  }

  const {
    chars,
    bban_regexp: bbanRegexp
  } = countrySpec;
  const bbanMask = (0, _fp.flow)(s => s.slice(1, -1).match(/([^{}]+)(\{\d+)/g), (0, _fp.map)(patternBlock => {
    const [pattern, repeats] = patternBlock.split('{');
    return Array(+repeats).fill(new RegExp(pattern));
  }), _fp.flatten)(bbanRegexp);
  const countryMask = country.split('');
  const internationalMask = countryMask.concat(Array(chars - countryMask.length - bbanMask.length).fill(/[0-9]/));
  const electronicMask = internationalMask.concat(bbanMask);
  return (0, _fp.flow)((0, _fp.chunk)(printBlockSize), (0, _fp.map)((0, _fp.concat)([' '])), _fp.flatten, (0, _fp.drop)(1))(electronicMask);
};

exports.default = _default;